import {
  Maybe,
  TodayGiftFragment,
  TodayGiftListQuery,
} from '../../../graphql/generated/types';

export function setTodayGiftListQueryData(
  data: TodayGiftListQuery,
  receiveTicketFree: TodayGiftFragment,
  ticketUid: Maybe<number>
) {
  return setGraphqlData(data, receiveTicketFree, ticketUid);
}

function setGraphqlData(
  data: TodayGiftListQuery,
  receiveTicketFree: TodayGiftFragment,
  ticketUid: Maybe<number>
) {
  if (!data || !data.todayGiftList) {
    return data;
  }
  const newTodayGiftList = data?.todayGiftList?.list?.map(todayGift => {
    if (todayGift.ticketUid === ticketUid) {
      return {
        ...todayGift,
        isReceived: true,
        row5: receiveTicketFree?.ticketExpiredText,
      };
    }
    return todayGift;
  });
  const newPromotionList = data?.todayGiftList?.promotionList?.map(item => {
    if (item.ticketUid === receiveTicketFree.uid) {
      return {
        ...item,
        isReceived: true,
        row5: receiveTicketFree?.ticketExpiredText,
      };
    }
    return item;
  });
  const newHelixList = data.todayGiftList.helixList.map(section => ({
    ...section,
    list: section.list.map(item => {
      if (
        item.ticketUid === receiveTicketFree.uid &&
        item.seriesId === receiveTicketFree.seriesId
      ) {
        return {
          ...item,
          isReceived: true,
          row5: receiveTicketFree?.ticketExpiredText,
        };
      }
      return item;
    }),
  }));
  return {
    ...data,
    todayGiftList: {
      ...data.todayGiftList,
      list: newTodayGiftList,
      promotionList: newPromotionList,
      helixList: newHelixList,
      receivableTicketCount: Math.max(
        0,
        (data.todayGiftList.receivableTicketCount ?? 0) -
          receiveTicketFree.ticketCount
      ),
    },
  };
}
